import { HttpClient, HttpEvent, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/shared/services/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmsServicesService {

  constructor(private api : ApiService,private http: HttpClient) { 
  }
getVendorInfo(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
    const url = `${environment.New_BASE_DOMAIN}ftl-service/vendor/getVendorInfo?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
    return this.api.post(url,formData);
  } 

  getUsers(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
    const url = `${environment.New_BASE_DOMAIN}account-service/user/getUsers?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
    return this.api.post(url,formData);
  } 
  
  getRoleMappingList(){
    const url = `${environment.New_BASE_DOMAIN}account-service/access/getRoles`;
    return this.api.get(url);
  } 

  addVendorAndEmployee(formData:any){
    const url = (environment.New_BASE_DOMAIN + 'auth-service/auth/createUser')
    return this.api.post(url,formData);
  }
  updateUser(formData:any){
    const url = (environment.New_BASE_DOMAIN + 'ftl-service/user/update')
    return this.api.post(url,formData);
  }
  addUser(formData:any){
    const url = (environment.New_BASE_DOMAIN + 'ftl-service/user/add')
    return this.api.post(url,formData);
  }
  createAccount(formData:any){
    const url = (environment.New_BASE_DOMAIN + 'account-service/config/createAccount')
    return this.api.post(url,formData);
  }
  updateAccount(formData:any){
    const url = (environment.New_BASE_DOMAIN + 'account-service/account/addOrUpdate')
    return this.api.post(url,formData);
  }
  
  
  getAccounts(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
    const url = `${environment.New_BASE_DOMAIN}account-service/account/getAccountInfo?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
    return this.api.post(url,formData);
  }
  
  getAccountMappings(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
    const url = `${environment.New_BASE_DOMAIN}account-service/info/getAccountMappings?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
    return this.api.post(url,formData);
  }

  addOrUpdateAccountMapping(formData:any){
    const url = `${environment.New_BASE_DOMAIN}account-service/config/addOrUpdateAccountMapping`;
    return this.api.post(url,formData);
  }

quickCodeCategory(){
  const url = (environment.New_BASE_DOMAIN + '/tms-service/master/getAllMasterCategory')
  return this.api.get(url);
}

quickCodeList(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}tms-service/master/getQuickCodes?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
}

addQuickCode(formData:any){
    const url = (environment.New_BASE_DOMAIN + '/tms-service/master/addOrUpdateQuickCode')
    return this.api.post(url,formData);
}

employeesList(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}ftl-service/employee/getEmployees?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
}
addMasterEmployee(formData:any){
  const url = (environment.New_BASE_DOMAIN + '/ftl-service/employee/addOrUpdate')
  return this.api.post(url,formData);
}
getQuickCodeListByCategoryId(ids:any){
  let url = `${environment.New_BASE_DOMAIN}tms-service/master/getQuickCodeListByCategoryId`
  if (ids) {
    url += `?categoryId=${ids}`;
  }
  return this.api.get(url);
}
expenseAddOrUpdate(formData:any){
  const url = (environment.New_BASE_DOMAIN + '/ftl-service/expense/addOrUpdate')
  return this.api.post(url,formData);
}
getExpenseList(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}ftl-service/expense/getExpenses?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
}
deleteExpense(id:any){
  const url = `${environment.New_BASE_DOMAIN}ftl-service/expense/deleteExpenses?id=${id}`
  return this.api.delete(url);
}


getWarehouseList(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}warehouse-service/info/getWarehouseByFilter?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
}

createWarehouse(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'warehouse-service/config/createWarehouse')
  return this.api.post(url,formData);
}
updateWarehouse(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'warehouse-service/config/updateWarehouse')
  return this.api.put(url,formData);
}
getWarehouseByFilter(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}warehouse-service/info/getWarehouseByFilter?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
}

upload(file: File): Observable<HttpEvent<any>> {
  var url :any
  const formData: FormData = new FormData();
  formData.append('file', file);
  const headers = new HttpHeaders({
    'VER': '1',
    'DEVICE-TYPE':'Web'
  });
  // headers.append('Content-Type', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
  url = `${environment.New_BASE_DOMAIN}utils-service/uploads/uploadFiles`;

  const req = new HttpRequest('POST', url, formData, {
    headers,
    reportProgress: true,
    responseType: 'json'
  });
  return this.http.request(req);
}

approvalAddOrUpdate(formData:any){
  const url = (environment.New_BASE_DOMAIN + '/ftl-service/approval/addOrUpdate')
  return this.api.post(url,formData);
}
getApprovalMatrices(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}ftl-service/approval/getApprovalMatrices?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
}
deleteApprovalMatrices(id:any){
  const url = `${environment.New_BASE_DOMAIN}ftl-service/approvalMatrices/deleteApprovalMatrices?id=${id}`
  return this.api.delete(url);
}
bulkApprovalMatrices(formData:any){
  const url = (environment.New_BASE_DOMAIN + '/ftl-service/approval/addOrUpdate')
  return this.api.post(url,formData);
}

getRevenueAttributes(formData:any,pageNumber:any,pageSize:any){
  const url = `${environment.New_BASE_DOMAIN}ftl-service/revenue/getRevenueAttributes?pageNumber=${pageNumber}&pageSize=${pageSize}`;
  return this.api.post(url,formData);
}
bulkAddOrUpdateAttribute(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'ftl-service/revenue/bulkAddOrUpdateAttribute')
  return this.api.post(url,formData);
}

getExpenseAttributes(formData:any,pageNumber:any,pageSize:any){
  const url = `${environment.New_BASE_DOMAIN}ftl-service/expense/getExpenseAttributes?pageNumber=${pageNumber}&pageSize=${pageSize}`;
  return this.api.post(url,formData);
}
expensesBulkAddOrUpdateAttribute(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'ftl-service/expense/bulkAddOrUpdateAttribute')
  return this.api.post(url,formData);
}
isInvoiceNumberExist(invoiceNumber:any,vendorId:any){
  const url = `${environment.New_BASE_DOMAIN}ftl-service/invoice/isInvoiceNumberExist?invoiceNumber=${invoiceNumber}&vendorId=${vendorId}`;
  return this.api.get(url);
} 







// ftl services

getRoutes(formData:any,pageNumber:any,pageSize:any){
  const url = `${environment.New_BASE_DOMAIN}tms-service/route/getRoutes?pageNumber=${pageNumber}&pageSize=${pageSize}`;
  return this.api.post(url,formData);
}
routeAddOrUpdate(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'tms-service/route/addOrUpdate')
  return this.api.post(url,formData);
}

getVehicleType(formData:any,pageNumber:any,pageSize:any){
  const url = `${environment.New_BASE_DOMAIN}tms-service/vehicle/getVehicleType?pageNumber=${pageNumber}&pageSize=${pageSize}`;
  return this.api.post(url,formData);
}
addVehicleType(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'ftl-service/vehicle/addOrUpdate')
  return this.api.post(url,formData);
}



getPincodeDetails(pincode:any): Observable<any> {
  const url = `${environment.New_BASE_DOMAIN}utils-service/master/getPincode?pageNumber=0&pageSize=1`;
  const payload = [{key: 'PINCODE_IN', value: pincode}];
  const headers = new HttpHeaders({
    'AuthUrl': `${environment.New_BASE_DOMAIN}/ftl-auth-service/validate/user`,
  });
  
  const req = new HttpRequest('POST', url, payload, {
    headers,
    reportProgress: true,
    responseType: 'json'
  });
  return this.http.request(req);
}


getLocations(formData:any,pageNumber:any,pageSize:any){
  const url = `${environment.New_BASE_DOMAIN}tms-service/location/getLocations?pageNumber=${pageNumber}&pageSize=${pageSize}`;
  return this.api.post(url,formData);
}
addlocation(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'tms-service/location/addOrUpdate')
  return this.api.post(url,formData);
}

getStatus(){
  const url = `${environment.New_BASE_DOMAIN}ftl-service/master/getMasterStatus`;
  return this.api.get(url);
} 

getUser(mobile:any,email:any,username:any){
  const baseUrl = `${environment.BASE_DOMAIN}ftl-service/user/getUsers`;
  let params: string[] = [];
  if (mobile) {
    params.push(`mobile=${mobile}`);
  }
  if (email) {
    params.push(`email=${email}`);
  }
  if (username) {
    params.push(`username=${username}`);
  }
  if (params.length === 0) {
    return null;  
  }
  const finalUrl = `${baseUrl}?${params.join('&')}`;
  console.log(finalUrl,'finalUrl')
  // const url = `${environment.BASE_DOMAIN}ftl-service/user/getUser?mobile=${mobile}&email=${email}&username=${username}`
  return this.api.get(finalUrl);
}

getB2bCustomers(formData:any,pageNumber:any,pageSize:any){
  const url = `${environment.New_BASE_DOMAIN}account-service/customer/getCustomerInfo?pageNumber=${pageNumber}&pageSize=${pageSize}`;
  return this.api.post(url,formData);
}
updateB2bCustomer(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'account-service/customer/addOrUpdate')
  return this.api.post(url,formData);
}
getCustomerContracts(formData:any,pageNumber:any,pageSize:any){
  const url = `${environment.New_BASE_DOMAIN}account-service/customer/getCustomerContract?pageNumber=${pageNumber}&pageSize=${pageSize}`;
  return this.api.post(url,formData);
}
addUpdateContract(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'account-service/customer/contract/addOrUpdate')
  return this.api.post(url,formData);
}
getRoles(){
  const url = (environment.New_BASE_DOMAIN + 'account-service/access/getRoles')
  return this.api.get(url);
}

}
